import axios from 'axios';

// 直接全部用post请求
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
    baseURL: "/api", // url = base url + request url
    timeout: 100000,
});
export default service;
